import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { clearLocalStorage, setLocal } from '../../helper/storage'
import { axiosInstance } from '../../axios/interceptor'

export const userLogin = createAsyncThunk('auth/login', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post('/admin/auth/login', data)
    if (response?.data) {
      setLocal('authToken', response?.data?.token)
      setLocal('refrteshToken', response?.data?.refreshToken)
    }
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const userLogout = createAsyncThunk('auth/logout', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get('/logout')
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const forgotPassword = createAsyncThunk('auth/forgotPassword', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post(`/admin/auth/forgot-password`, data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const resetPassword = createAsyncThunk('auth/resetPassword', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post(`/admin/auth/update-password`, data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const changePassword = createAsyncThunk('auth/changePassword', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post(`/admin/auth/change-password`, data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getUser = createAsyncThunk('auth/me', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get('/admin/auth/me')
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

const initialState = {
  isLoading: false,
  user: null,
  error: null
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    resetAuthState: (state) => {
      state.user = null
      clearLocalStorage()
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(userLogin.pending, (state) => {
        state.isLoading = true
      })
      .addCase(userLogin.fulfilled, (state, action) => {
        state.isLoading = false
        state.user = action.payload?.data?.data
      })
      .addCase(userLogin.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(userLogout.pending, (state) => {
        state.isLoading = true
      })
      .addCase(userLogout.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(userLogout.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(forgotPassword.pending, (state) => {
        state.isLoading = true
      })
      .addCase(forgotPassword.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(forgotPassword.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(resetPassword.pending, (state) => {
        state.isLoading = true
      })
      .addCase(resetPassword.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(resetPassword.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(changePassword.pending, (state) => {
        state.isLoading = true
      })
      .addCase(changePassword.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(changePassword.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getUser.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.user = action.payload?.data?.data
        state.isLoading = false
      })
      .addCase(getUser.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
  }
})

export const { resetAuthState } = authSlice.actions
export default authSlice.reducer
